/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Files_Toast_Reingest_Bulk_Success_DescInputs */

const es_settings_files_toast_reingest_bulk_success_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_Bulk_Success_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivo(s) re-ingestados.`)
};

const en_settings_files_toast_reingest_bulk_success_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_Bulk_Success_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} file(s) re-ingested.`)
};

/**
* | output |
* | --- |
* | "{count} file(s) re-ingested." |
*
* @param {Settings_Files_Toast_Reingest_Bulk_Success_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_reingest_bulk_success_desc = /** @type {((inputs: Settings_Files_Toast_Reingest_Bulk_Success_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Reingest_Bulk_Success_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_reingest_bulk_success_desc(inputs)
	return en_settings_files_toast_reingest_bulk_success_desc(inputs)
});
export { settings_files_toast_reingest_bulk_success_desc as "settings.files.toast.reingest_bulk_success_desc" }